import { graphql } from "react-relay"

export const chDuplicatePatientsByPatientIdQuery = graphql`
  query chDuplicatePatientsByPatientIdQuery($patientId: ID!) {
    ch_duplicatePatientsByPatientId(patientId: $patientId) {
      id
      firstName
      lastName
      gender
      displayId
    }
  }
`
